export const actions = {
  SET_USER_PRICES({ commit, rootState }) {},
}
